export const AUTH_TRANSITION_STORAGE_KEY = "mgfood_auth_transition_started_at";
export const AUTH_TRANSITION_WINDOW_MS = 10000;

export const hasPendingAuthTransition = (
  transitionStartedAt,
  now = Date.now(),
) => {
  const startedAt = Number(transitionStartedAt);

  if (!startedAt) {
    return false;
  }

  return now - startedAt < AUTH_TRANSITION_WINDOW_MS;
};

export const getProtectedRouteState = ({
  authResolved,
  isAuthenticated,
  authTransitionPending = false,
}) => {
  if (!authResolved) {
    return "loading";
  }

  if (authTransitionPending) {
    return "loading";
  }

  return isAuthenticated ? "allow" : "redirect";
};
